import React, { useEffect, useState } from "react";
import AdminPharmacyTable from "./AdminPharmacyTable";
import StatusSidebar from "./StatusSidebar";
import { fetchAllPharmacies } from "../../api/pharmacy";
import AdminLoginForm from "./AdminLoginForm";

const AdminLogin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [pharmacies, setPharmacies] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");

  const loadPharmacies = async () => {
    const data = await fetchAllPharmacies();
    setPharmacies(data);
  };

  useEffect(() => {
    if (isAuthenticated) {
      loadPharmacies();
    }
  }, [isAuthenticated]);

  const filteredPharmacies =
    statusFilter === "all"
      ? pharmacies
      : pharmacies.filter(
          (pharmacy) =>
            (pharmacy.status || "").toLowerCase() === statusFilter.toLowerCase()
        );

  if (!isAuthenticated) {
    return <AdminLoginForm onLoginSuccess={() => setIsAuthenticated(true)} />;
  }

  return (
    <div style={{ display: "flex" }}>
      <StatusSidebar
        selectedStatus={statusFilter}
        onStatusClick={setStatusFilter}
      />
      <AdminPharmacyTable
        data={filteredPharmacies}
        status={statusFilter}
        onStatusUpdated={loadPharmacies}
      />
    </div>
  );
};

export default AdminLogin;